import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import MicrosoftSSOImage from '@/components/icons/svg/microsoft-sso-image';
import { withStyles } from '@/decorators';
export const styles = () => ({
    button: {
        height: '100%',
        width: '100%',
    },
});
const MicrsoftSSOButton = withStyles(styles)(function MicrsoftSSOButton({ classes, ssoLogin, }) {
    return (<ButtonBase classes={{ root: classes.button }} onClick={ssoLogin}>
      <MicrosoftSSOImage classes={{ root: classes.button }} fontSize="large"/>
    </ButtonBase>);
});
export default MicrsoftSSOButton;
